import Vue from 'vue';
import '@/icons'; // icon
import '@/permission'; // permission control

import './directives';
import i18n from './lang';
import App from './App';
import store from './store';
import router from './router';
import { initVueConfig } from './init-vue-config';
import { intVueExtend } from './init-vue-extend';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'; // global css
import './assets/iconfont/iconfont.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// 接入监控
// import sentryVue from '@xy/sentry-vue';
// const { RELEASE, NEED_REPORT, DSN } = require('./sentry.config.js');
// if (NEED_REPORT) {
//   sentryVue.init({
//     dsn: DSN,
//     // 传入Vue中的router
//     routes: router,
//     responseErrorHandle: true,
//     release: RELEASE,
//   });
// }

// initSentry();
intVueExtend();
initVueConfig();

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
});
